<template>
    <div>
        <HeaderItem />
        <div class="subject">
            <div class="list-group">
                <routeTabComponent />
                <div class="panel">
                    <div class="InternetThings" v-loading="dashboardLoading">
                        <el-scrollbar class="pageContentModal-scrollbar" v-if="sreeens.length!=0">
                            <ul class="aeroiot-projects aeroiotflex_row">
                                <li
                                    class="dashboard-item-li-style"
                                    v-for="item in sreeens"
                                    :key="item.id"
                                >
                                    <div class="aeroiot-projects-item">
                                        <div class="aeroiot-projects-img">
                                            <el-image
                                                class="aeroiot-projects-img-el-image"
                                                style="
                                                    width: 100%;
                                                    height: 100%;
                                                "
                                                :src="item.narImg"
                                            >
                                                <div
                                                    slot="error"
                                                    class="aeroiotflex_center"
                                                    style="
                                                        width: 100%;
                                                        height: 100%;
                                                        background-color: #fff;
                                                    "
                                                >
                                                    <span class="image-slot"
                                                        >工程监测云</span
                                                    >
                                                </div></el-image
                                            >
                                            <div
                                                class="
                                                    aeroiot-projects-toolbtns
                                                "
                                            >
                                                <el-button
                                                    class="edit-project"
                                                    type="primary"
                                                    size="small"
                                                    @click="
                                                        goedit(
                                                            item.id
                                                        )
                                                    "
                                                    >编辑</el-button
                                                >                             
                                                <div
                                                    class="aeroiotflex_center aeroiot-projects-subbtns"
                                                    v-if="item.status == 2"
                                                >
                                                    <button
                                                    @click="goToLook(item.id)"
                                                    class="aeroiotflex_center"
                                                    >
                                                    <i class="iconfont icon-chakan"></i>
                                                    <span>查看</span>
                                                    </button>
                                                </div>


                                                <div
                                                    class="
                                                        aeroiotflex_center
                                                        aeroiot-projects-subbtns
                                                    "
                                                    v-if="item.status == 2"
                                                ></div>
                                            </div>
                                                                                    <div class="projects-status">
                                        <span v-if="item.status == 1" style="background: #909399"
                                            >未发布</span
                                        >
                                        <span v-else-if="item.status == 2" style="background: #67c23a"
                                            >已发布</span
                                        >
                                        </div>
                                        </div>




                                        <div
                                            class="
                                                aeroiot-projects-msg
                                                aeroiotflex_between
                                            "
                                        >
                                            <div
                                                class="
                                                    aeroiot-projects-msg-title
                                                "
                                            >
                                                <strong>{{ item.name }}</strong>
                                            </div>
                                            <div class="aeroiotflex_row">
                                                <time class=""
                                                    >创建日期：{{
                                                        item.createDate
                                                    }}</time
                                                >
                                            </div>
                                        </div>
                                    </div>
                                </li>
                            </ul>
                            <div class="aeroiot-pagination" v-show="total > 0">
                                <el-pagination
                                    style="text-align: center; margin-top: 20px"
                                    background
                                    layout="prev, pager, next"
                                    :page-size="param.count"
                                    :total="total"
                                    :current-page="param.page"
                                    @current-change="indexchange"
                                >
                                </el-pagination>
                            </div>
                        </el-scrollbar>
                        <div class="noMoniterBox aeroiotflex_center" v-else>
                            <div class="noMoniterBoxImg aeroiotflex_center">
                              <img src="@/assets/monitorListNoData.png" alt="">
                            </div>
                            <div>大屏列表为空，快去创建大屏吧～</div>
                        </div>
                    </div>
                </div>
            </div>

            <SignIn></SignIn>
        </div>
        <telephoneModule />
    </div>
</template>

<script>
import HeaderItem from "@/components/HeaderItem";
import SignIn from "@/components/SignIn";
import telephoneModule from "@/components/telephoneModule";
import routeTabComponent from "@/components/routeTabComponent";
import {getToken} from '@/utils/auth.js'

export default {
    components: {
        HeaderItem,
        SignIn,
        routeTabComponent,
        telephoneModule,
    },
    data() {
        return {
            total: 0,
            param: {
                count: 9,
                page: 1,
            },
            sreeens: [],
            dashboardLoading:false,
        };
    },
    mounted() {
        this.getScreens();
    },
    methods: {
        indexchange(index) {
              this.param.page = index;
              this.getScreens();
        },
        goedit(id){
            let routerUrl = 'https://dashboard.aeroiot.cn/#/index?id='+id
            window.open(routerUrl, "_blank");
        },
        goToLook(id) {
            let routerUrl = 'https://dashboard.aeroiot.cn/#/dashboard?id='+id
            window.open(routerUrl, "_blank");
        },
        getScreens(){
            this.dashboardLoading = true
            this.sreeens = [];
            let requestURL = ''
            if( this.$apis.sso == 'http://hostsso.aeroiot.cn:9090/maxkey'){
                requestURL = 'http://192.168.1.153:5001/data/dashboard/usercenter/list'
                // requestURL = 'https://api-dashboard.aeroiot.cn/data/dashboard/usercenter/list'
            }else{
                requestURL = 'https://api-dashboard.aeroiot.cn/data/dashboard/usercenter/list'
            }
            this.$axios.get(requestURL+'?page='+this.param.page+'&count='+this.param.count,{headers:{
                'appToken':getToken()
            }}).then(res=>{
                if (res.data.code == 200) {
                    this.sreeens = res.data.result.data || [];
                    this.total = res.data.result.dataCount;
                    this.param.page = res.data.result.page
                } else {

                }
                this.dashboardLoading = false
            }).catch(e=>{
                this.dashboardLoading = false
                console.log('错误',e)
            })
        }
    },
};
</script>

<style scoped>



ul li {
  list-style: none;
  padding: 0px;
  margin: 0px;
}

a {
    text-decoration: none;
}

.subject {
    /* 20220523 隐藏左侧栏 */
    /* position: absolute; */
    /* width: calc(100% - 50px); */
    width: 100%;
    min-height: 100vh;
    background-color: #eaedf5;
    left: 50px;
    display: flex;
    flex-direction: row;
}

.subject .list-group {
    width: 1408px;
    position: relative;
    margin: 63px 20px 20px 15px;
    min-height: 782px;
}

.subject .list-group .panel {
    border-top: 1px solid;
    border-color: #e2e4e7;
    width: 100%;
    background-color: white;
}
.InternetThings {
    min-height: 740px;
}

.aeroiot-projects{
    flex-wrap: wrap;
    padding: 0 20px 20px;
}
.aeroiot-projects-item{
    align-items: stretch;
    background-color: #eef0f5;
    padding: 10px;
    border: 1px solid transparent;
}
.aeroiot-projects-img{
    width: 100%;
    height: 232px;
    flex-shrink: 0;
    position: relative;
}

.image-slot{
    text-shadow: #bdb7b7 -1px 1px 0, #fff 1px 1px 0;
    font-size: 24px;
    color: #fff;
}
.aeroiot-projects-toolbtns {
    position: absolute;
    width: 148px;
    top: 50%;
    left: 50%;
    right: 0;
    z-index: 2;
    -webkit-transform: translate(-50%,-50%);
    transform: translate(-50%,-50%);
    display: none;
}
.aeroiot-projects-img .edit-project{
    padding-left: 30px;
    padding-right: 30px;
    border-radius: 0;
    width: 148px;
}
.aeroiot-projects-msg {
    flex: 1;
    text-align: left;
    font-size: 14px;
    margin-top: 10px;
    color: #333;
}
.aeroiot-projects-msg-title {
    width: 50%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
.aeroiot-projects-msg time {
    color: #707070;
    font-size: 12px;
}


.aeroiot-pagination {
  margin-bottom: 40px;
}


.projects-status {
  position: absolute;
  top: 0px;
  left: 0px;
  z-index: 2;
}
.projects-status span{
    display: block;
    color: #fff;
    font-size: 12px;
    width: 50px;
    text-align: center;
    line-height: 24px;
    transform: scale(0.84);
    transform-origin: 0 0;
}
.aeroiot-projects-subbtns{
    margin-top: 10px;
    display: flex;
    justify-content: space-between;
    cursor: pointer;
}
.aeroiot-projects-subbtns button{
    color: white;
    width: 74px;
    background: transparent;
    border: none;
    align-items: flex-start;
    cursor: pointer;
}

.aeroiot-projects-subbtns button:hover{
    color: #6c85ff;
      width: 74px;
}
.aeroiot-projects-subbtns button:hover .iconfont{
    color: #6c85ff;
}



.aeroiot-pagination /deep/ .el-pagination .btn-prev{
      border-radius: 0;
      background-color: #eef0f5;
  }
.aeroiot-pagination /deep/ .el-pagination .btn-next{
      border-radius: 0;
      background-color: #eef0f5;
}
.aeroiot-pagination /deep/ .el-pagination .number{
      border-radius: 0;
      background-color: #eef0f5;
}
.aeroiot-pagination /deep/ .el-pagination .more{
      border-radius: 0;
      background-color: #eef0f5;
}
.aeroiot-projects-item:hover {
    border-color: #6c85ff;
}
.aeroiot-projects-item:hover .aeroiot-projects-toolbtns {
    display: block;
}
.aeroiot-projects-item:hover .aeroiot-projects-img-el-image::before{
    position: absolute;
    content: '';
    display: block;
    width: 100%;
    height: 100%;
    background: black;
    opacity:0.5;
}
.dashboard-item-li-style{
    padding: 10px; 
    width: 425px;
}
  .noMoniterBoxImg{
    width: 190px;
    height: 190px;
    background: #F4F4F4;
    border-radius: 50%;
    margin-top: 172px;
    margin-bottom: 30px;
  }
  .noMoniterBox{
    flex-direction:column;
    font-size: 14px;
    font-weight: 400;
    color: #999999;
  }
.el-button--primary {
    color: #fff;
    background-color: #6c85ff;
    border-color: #6c85ff
}

.el-button--primary:focus,.el-button--primary:hover {
    background: #899dff;
    border-color: #899dff;
    color: #fff
}
.icon-chakan{
    margin-right: 2px;
}
@media screen and (max-width:555px){
    .subject{
        background: rgba(240,241,243, 1);
    }
    .subject .list-group{
        margin: 50px 0px 20px 0px
    }
    .el-scrollbar__wrap{
        margin: 0!important;
    }
.aeroiot-projects{
    background: rgba(240,241,243, 1);
    padding: 0;
    margin-top: 5px;
    justify-content: space-between;
}
.InternetThings {
    min-height: 100vh;
}
.aeroiot-projects-item{
    background-color: #fff;
    padding: 5px;
}
.aeroiot-projects-msg-title{
    width: 100%;
}
.dashboard-item-li-style{
    padding: 5px; 
    width: 176px;
    height: 160px;
}
.aeroiot-projects-img{
    width: 158px!important;
    height: 99px!important;
}
.aeroiot-projects-msg{
    flex-direction: column;
    align-items: baseline;
}
.subject .list-group .panel{
   background-color:rgba(240,241,243, 1); 
}
}
</style>


// WEBPACK FOOTER //
// src/view/dashboardMannage/index.vue